import ow from "ow";

/**
 * Returns an object without the properties from the properties array.
 *
 * @param object - The object to remove the properties from.
 * @param properties - An array of properties to remove.
 */
export const removeProperties = <T extends object>(object: T, properties: string[]): Partial<T> => {
	if (!ow.isValid(object, ow.object)) {
		return;
	}

	const result = { ...(object as object) } as T;

	for (const prop of properties) {
		delete result[prop];
	}

	return result;
};
